import type { ISxProps } from '@/CommonComponents/types'

export const bitbucketOutlinedIcon = ({ sx, color }: { sx?: ISxProps; color?: string }) => {
  // Filter out null values from sx to avoid TypeScript errors
  const filteredSx = sx ? Object.fromEntries(Object.entries(sx).filter(([_, value]) => value !== null)) : {}

  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      style={{ width: '1em', height: '1em', ...filteredSx }}
      color={color}
    >
      {/* eslint-disable-next-line max-len */}
      <path d="M2.5 3.5l1.5 1.5h16l1.5-1.5M4 6v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6M8 10h8M8 14h6" />
      <path d="M6 8l2 8h8l2-8" />
    </svg>
  )
}
